import { HTMLAttributes } from 'react'
import { map } from 'lodash'

import BorderedCard from '@/components/base/bordered-card'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Heading from '@/components/sections/heading'
import Spacer from '@/components/sections/spacer'

import { useGridMotion } from './motion/grid'
import { WPImage } from '@/types'

export type CategoriesGridProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    collection: {
      name: string
      image: WPImage
      link: string
    }[]
  }>

const CategoriesGrid = ({ collection, ...props }: CategoriesGridProps) => {
  const { motionRef } = useGridMotion()

  return (
    <>
      <Spacer variant="2xl" />

      <Heading />

      <Spacer variant="sm" />

      <Section ref={motionRef} {...props}>
        <Container>
          <Grid className="gap-y-[3.2rem] md:gap-y-[5.6rem]">
            {map(collection, ({ name, image, link }, index) => (
              <BorderedCard
                key={`card-${index}`}
                image={image}
                title={name}
                link={link}
                className="col-span-2 md:col-span-2 lg:col-span-4"
                data-motion-card
              />
            ))}
          </Grid>
        </Container>
      </Section>
    </>
  )
}

export default CategoriesGrid
